import {
  IcreateMainContactAPIResponse,
  IcreateMainContactAPIResponseBody,
  IgetMainContactsAPIResponse,
  IremoveMainContactAPIResponse,
  IupdateMainContactAPIBody,
  IupdateMainContactAPIResponse,
} from 'api/endpoints/mainContacts/mainContacts.response.interface';
import { getBasePath } from '../../utils/config';
import { safeJsonParse, buildUrl } from 'api/utils/fetchHelpers';

export const getMainContactsAPI = async ({
  clientId,
  token,
}: {
  clientId: string;
  token: string;
}): Promise<IgetMainContactsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/get_client_contacts`, {
      client_id: clientId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const createMainContactAPI = async ({
  clientId,
  contact,
  token,
}: {
  clientId: string;
  contact: IcreateMainContactAPIResponseBody;
  token: string;
}): Promise<IcreateMainContactAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(contact),
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/create_client_contact`, {
      client_id: clientId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const updateMainContactAPI = async ({
  body,
  token,
}: {
  body: IupdateMainContactAPIBody;
  token: string;
}): Promise<IupdateMainContactAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/client_profile/update_client_contact`,
    params
  );
  return await safeJsonParse(response);
};

export const removeMainContactAPI = async ({
  contactId,
  token,
}: {
  contactId: string;
  token: string;
}): Promise<IremoveMainContactAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/delete_client_contact`, {
      contact_id: contactId,
    }),
    params
  );
  return await safeJsonParse(response);
};
